export default {
  // locale
  sk: "Slovenský",
  en: "English",

  // settings
  member: "Member",
  admin: "Administrator",

  LayoutListDefault: "List basic",
  LayoutListGreen: "List green",
  LayoutListWhite: "List white",
  LayoutImageDefault: "Image basic",
  LayoutImageOrange: "Image orange",
  LayoutImageDefaultWithNumber: "Image basic numbered",
  LayoutImageOrangeWithNumber: "Image orange numbered",
  LayoutCombinedDefault: "Combined basic",
  LayoutCombinedBlack: "Combined black",
  LayoutImage3x3: "Images 3x3",

  //errors
  "user-not-found":
    "User with given email does not exist. Please check if the email you entered is correct and try again.",
  "wrong-password":
    "The password you entered is incorrect. If you forgot your password click on the 'Forgot password' link below.",
  "network-request-failed":
    "A network error has occurred. Please check your internet connection and try again later.",
  "login-error":
    "An error occurred while trying to login. if the problem persists, please contact us.",
  "google-auth-error": "Google authentication failed.",
  "email-already-in-use":
    "The email address is already in use by another account.",
  "signup-error":
    "An error occurred while trying to create your account. if the problem persists, please contact us.",
  "read-project-error": "Failed to read project data.",
  "read-device-data-error":
    "Failed to load data for device, trying again in 30s.",
  "reset-password-error":
    "An error occurred while trying to reset your password. if the problem persists, please contact us.",
  "duplicit-pairing-code": "Failed to add pairing code. Code already added.",
  "add-pairing-code-error": "Pairing code add failed.",
  "save-device-name-error": "Failed to set device name.",
  "remove-device-error": "Failed to remove device from location.",
  "member-already-exists": "Failed to add member. Member already exists.",
  "add-member-error": "Failed to add new team member.",
  "remove-member-error": "Failed to remove team member.",
  "create-meal-error": "Failed to create meal.",
  "edit-meal-error": "Failed to edit meal.",
  "remove-meal-error": "Failed to remove meal.",
  "save-meals-sortby-error": "Failed to change meals sort by setting.",
  "modify-offer-error": "Failed to modify offer.",
  "add-to-offer-error": "Failed to modify offer.",
  "remove-from-offer-error": "Failed to modify offer.",
  "create-demo-error": "Failed to create location.",
  "create-project-error": "Failed to create location.",
  "add-screen-error": "Failed to add screen.",
  "remove-screen-error": "Failed to remove the screen.",
  "set-lang-error": "Failed to set language setting.",
  "remove-project-error": "Failed to remove location.",
  "save-offer-error": "Failed to save offer.",
  "remove-offer-error": "Failed to remove offer."
}
